<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on: dialogo }">
      <v-list-item v-on="dialogo" @click.stop="dialog = true">
        <v-list-item-title class="red--text">Eliminar</v-list-item-title>
      </v-list-item>
    </template>
    <!-- Modal -->
    <v-card>
      <!-- Título -->
      <v-card-title>
        ¿Estás seguro de que deseas eliminar la sucursal?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
        <v-btn class="red--text" text @click="deleteBranch">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// importar servicios
import BranchesServices from "@/services/BranchesServices";

export default {
  props: {
    branchId: {
      type: String
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    deleteBranch: async function() {
      try {
        // Eliminar sucursal
        await BranchesServices.deleteBranch(this.branchId);

        // Crrar diálogo
        this.dialog = false;

        // Emitir evento
        this.$emit("branch-deleted");
      } catch (err) {
        // Emitir evento para el error
        this.$emit("branch-error", err.message);
      }
    }
  }
};
</script>
